import { envTypes } from './env-types'

export { envTypes }

const keys = Object.entries(envTypes)

const priv = `params x1 x2 y1 y2 a0 a1 a2 b0 b1 b2 alpha beta sample step
c1 c2 a3 v1 v2 v3 floats index engine rateKind initial
stepf targetf
dpn exn edn predelay
d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11
mask lp1 lp2 lp3 excPhase pdn
offsetIndex offsetCurrent offsetTarget phase
prevLevel gainReduction attackRecip releaseRecip
lastTrig hasTrig table gainv
A a a2 b b2 c g g0 ah bh ainv k z0 z1 z2 z3 z4 C s
`.split(/\s+/g)

export type Range = [number | string, number | string, number | string, number]
const ranges: Record<string, Range> = {
  hz: [0, 'arf', 'arf/42.0', .5],
  cut: [10, 'arf', 'arf/42.0', .5],
  hpf: [0.0001, 'arf', '1000', .5],
  q: [0.01, 5, 1, 1],
  ms: [0, 1000, 200, 1],
  fb: [0, 0.99, 0.5, 1],
  threshold: [0, 1, 0.5, 1],
  samples: [1, Number.MAX_SAFE_INTEGER, 'ar', 1],
}

const gens: Record<string, {
  id: string
  label: string
  stack: boolean
  params: string[]
  /** [min,max,default,slope] */
  range: Range | null
}[]> = {}


for (const [id, type] of keys) {
  const params = type.split(')')[0].split('(')[1].split(' ')
  const [pre, name, getOrSet, label] = id.split('_')

  if (priv[0] === '_' || priv.includes(label)) continue

  if (pre === 'gen') {
    gens[name] ??= []
    const stack = (
      ['in'].includes(label)
      || Object.keys(gens[name]).length === 0
    ) && !['offset'].includes(label)
    if (getOrSet === 'set') {
      gens[name].push({
        id,
        label,
        stack,
        params,
        range: ranges[label] ?? null
      })
    }
  }
}

for (const key in gens) {
  if (gens[key].find((x: any) => x.label === 'cut')
    && !gens[key].find((x: any) => x.label === 'in')) {
    gens[key].splice(1, 0, gens.biquad[0])
  }
}

delete gens.gen

const inheritOsc = 'sin exp saw ramp sqr tri noise'.split(/\s+/g)
inheritOsc.forEach((x) => {
  gens[x].push(...gens.osc)
})
delete gens.osc

const inheritSample = 'freesound say'.split(/\s+/g)
inheritSample.forEach((x) => {
  gens[x].push(...gens.sample)
})

delete gens.biquad
delete gens.sample

const Proto = [
  [['dc', 'rate'], []],
  [['blp', 'bhp', 'bbp', 'bno', 'bpk', 'bap', 'bls', 'bhs'], ['biquad', 'gen']],
  [['slp', 'sbp', 'shp', 'sap', 'sno', 'spk'], ['svf', 'gen']],
  [['mlp', 'mhp'], ['moog', 'gen']],
  [inheritSample, ['sample', 'gen']],
  [['delay', 'daverb', 'tap', 'comp', 'lp', 'diode',
    'dclip', 'dcliplin', 'dclipexp',
    'clip', 'clamp'], ['gen']],
  [inheritOsc, ['osc', 'gen']],
]

const protoMap = new Map(Proto.flatMap(([keys, chain]) =>
  keys.map((key) => [key, [key, ...chain]])
))

export function envLookupMethod(text: string, method: string) {
  const protoChain = protoMap.get(text) ?? [text, 'gen']

  // ['dc', 'rate'].includes(text)
  //   ? [text]
  //   : ['blp', 'bhp', 'bbp', 'bno', 'bpk', 'bap', 'bls', 'bhs'].includes(text)
  //     ? [text, 'biquad', 'gen']
  //     : ['slp', 'sbp', 'shp', 'sap', 'sno', 'spk'].includes(text)
  //       ? [text, 'svf', 'gen']
  //       : ['mlp', 'mhp'].includes(text)
  //         ? [text, 'moog', 'gen']
  //         : ['freesound', 'say'].includes(text)
  //           ? [text, 'sample', 'gen']
  //           : [
  //             'delay', 'daverb', 'tap', 'comp', 'lp', 'diode',
  //             'dclip', 'dcliplin', 'dclipexp',
  //             'clip', 'clamp',
  //           ].includes(text)
  //             ? [text, 'gen']
  //             : [text, 'osc', 'gen']

  for (const kind of protoChain) {
    let id: string
    id = `gen_${kind}_${method}`
    if (id in envTypes) return id
    id = `${id}_override`
    if (id in envTypes) return id
  }
}

// console.log(gens)
export { gens as envGens }
